const PROVIDER_LABELS: Record<string, string> = {
	github: "GitHub",
	google: "Google",
	apple: "Apple",
	discord: "Discord",
	twitter: "X (Twitter)",
};

export function getOAuthProviderLabel(provider: string | null): string {
	if (!provider) {
		return "social provider";
	}
	return PROVIDER_LABELS[provider] ?? "social provider";
}

export function getOAuthCallbackErrorMessage({
	error,
	provider,
}: {
	error: string | null;
	errorDescription: string | null;
	provider: string | null;
}): string | null {
	if (!error) {
		return null;
	}

	if (error === "signup_disabled") {
		return `No Sigma account is linked to this ${getOAuthProviderLabel(provider)} account yet. Create a Sigma account first, then link ${getOAuthProviderLabel(provider)} from your account settings to use it for sign-in and recovery.`;
	}

	if (error === "account_not_linked") {
		return `This ${getOAuthProviderLabel(provider)} account's email could not be verified, so it wasn't linked automatically. Sign in with your existing method, then link it from Settings.`;
	}

	if (error.replace(/[_-]/g, " ").includes("already linked")) {
		return `This ${getOAuthProviderLabel(provider)} account is already linked to another user.`;
	}

	if (error === "invalid_signature") {
		return "Your authorization session has expired. Please return to the application and try signing in again.";
	}

	if (error === "access_denied") {
		return "Authorization was cancelled. You can try again when you're ready.";
	}

	return "Authentication could not be completed. Please try again.";
}
